import {useSelector} from "react-redux";
import {Suspense, useMemo} from "react";
import {Outlet, useLocation,} from "react-router-dom";
import {Header} from "../components/Header/Header";
import {Footer} from "../components/Footer/Footer";
import {MobileNav} from "../components/MobileNav/MobileNav";
import {CONSTANTS} from "../constants/constants";
import {LoadingScreen} from "../components/LoadingScreen/LoadingScreen";
import {HEADER_HIDDEN_ROUTES, MOBILE_NAV_VISIBLE_ROUTES} from "./helpers";
import s from "./Layout.module.css";

const LAYOUT_PORT = CONSTANTS.VALUE.ID_PORTS_CSS.LAYOUT_PORT;

export const Layout = () => {

  const {pathname} = useLocation();
  const isMobile = useSelector(state => state.layout.isMobile);

  const isMobileNavVisible = useMemo(
    () => isMobile && MOBILE_NAV_VISIBLE_ROUTES.includes(pathname),
    [isMobile, pathname]
  );

  const isHeaderHidden = useMemo(
    () => HEADER_HIDDEN_ROUTES.includes(pathname),
    [pathname]
  );

  return (
    <div className={s.wrapper} id={LAYOUT_PORT}>
      {!isHeaderHidden && <Header/>}
      <div className={'main'}>
        <Suspense fallback={<LoadingScreen/>}>
          <Outlet />
        </Suspense>
       </div>
      <Footer/>
      {(isMobileNavVisible && isMobile) && <MobileNav pathname={pathname}/>}
    </div>
  )
};